import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { FinanceService } from '../../services';
import { AppFilter, ConfirmModal, CommonServices } from 'src/modules/shared';
interface IInvoiceDetailModalContext {
  data: any;
  title?: string;
  isEdit?: boolean;
}
@Component({
  selector: 'app-edit-director-modal',
  templateUrl: './edit-director-modal.component.html',
  styleUrls: ['./edit-director-modal.component.scss'],
})
export class InvoiceDetailModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;

  companyDirectorForm: FormGroup;
  companyDirector: any;
  invoice: any;
  detailInvoice;
  paymentDetail: any;
  paymentInstructions: any;
  faqs;
  constructor(
    private commonServices: CommonServices,
    private companySvc: FinanceService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IInvoiceDetailModalContext, void, void>
  ) {
    this.companyDirectorForm = fb.group({
      firstName: [''],
      lastName: [''],
      middleName: [''],
      gender: [''],
      nationalityId: [''],
      countryOfOriginId: [''],
      nationalIdNumber: [''],
      organizationOwnershipTypeId: [''],
      shareholding: [''],
    });
    this.invoice = modal.context.data;
    // console.log(this.invoice);
    this.getInvoice();
    // if (!this.invoice.serviceAllowPartPayment) {

    // }
  }

  submit() {
    this.modal.approve(<any>{
      invoiceDetails: this.detailInvoice,
      paymentDetail: this.paymentDetail,
    });
    // this.modal.context.isEdit == true ? this.update() : this.save();
  }
  getInvoice() {
    this.pending = true;
    this.companySvc
      .getInvoiceDetail({
        params: { invoiceNumber: this.invoice.invoiceNumber },
      })
      .subscribe(
        (res) => {
          this.detailInvoice = res;
          this.getPayment();
          // setTimeout(() => {
          // 	this.modal.approve(null);
          // }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getPayment() {
    this.pending = true;
    this.companySvc
      .getInvoicePayment({
        params: { invoiceNumber: this.invoice.invoiceNumber },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.paymentDetail = res;
          this.paymentInstructions = res['paymentInstructions'];
          // setTimeout(() => {
          // 	this.modal.approve(null);
          // }, 2000);
        },
        (error) => {
          this.commonServices
            .getTemplate({ messageTemplateId: 'GENERIC_PAYMENT_INSTRUCTIONS' })
            .subscribe((res: any) => {
              this.faqs = res.notifcationTemlate;
            });
          this.pending = false;
          // this.error = error.error ? error.error : error;
        }
      );
    // );
  }
  save() {
    this.formSubmitAttempt = false;
    if (this.companyDirectorForm.valid) {
      this.pending = true;
      // this.companySvc.addCompanyEquipment({ body: this.companyDirectorForm.value }).subscribe(
      // 	(res) => {
      // 		this.pending = false;
      // 		this.success = 'Company director added successfully';
      // 		setTimeout(() => {
      // 			this.modal.approve(null);
      // 		}, 2000);
      // 	},
      // 	(error) => {
      // 		this.pending = false;
      // 		this.error = error.error ? error.error : error;
      // 	}
      // );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  update() {
    this.formSubmitAttempt = false;
    if (this.companyDirectorForm.valid) {
      this.pending = true;
      // this.companySvc
      // 	.updateCompanyEquipment({
      // 		id: this.companyDirector.organizationEquipmentId,
      // 		body: { ...this.companyDirector, ...this.companyDirectorForm.value }
      // 	})
      // 	.subscribe(
      // 		(res) => {
      // 			this.pending = false;
      // 			this.success = 'Company director updated successfully';
      // 			setTimeout(() => {
      // 				this.modal.approve(null);
      // 			}, 2000);
      // 		},
      // 		(error) => {
      // 			this.pending = false;
      // 			this.error = error.error ? error.error : error;
      // 		}
      // 	);
    } else {
      this.formSubmitAttempt = true;
    }
  }

  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class InvoiceDetailModal extends ComponentModalConfig<
  IInvoiceDetailModalContext,
  void,
  void
> {
  constructor(title: string, data: string, size: ModalSize = ModalSize.Small) {
    super(InvoiceDetailModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
